<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="クーポンの使用方法"
        ok-title="閉じる"
        ok-variant="yokumiru-gray"
        ok-only
        @ok="close"
        @hidden="close">
        <div class="modal-body">
            <div class="vc-step">
                <a href="/images/common/howtouse_coupon_01.png" target="_blank">
                    <img src="/images/common/howtouse_coupon_01.png">
                </a>
                <p class="mt-3 mb-5">1. 相談予約の際、お支払い方法の選択画面でクーポンを選択してください。</p>
            </div>
            <div class="vc-step">
                <a href="/images/common/howtouse_coupon_02.png" target="_blank">
                    <img src="/images/common/howtouse_coupon_02.png">
                </a>
                <p class="mt-3 mb-0">2. 予約確認画面にて、クーポンの使用により金額が割引されます。<br>内容に問題がなければ、そのまま予約を確定してください。</p>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'

    export default {
        name: 'HowToUseCouponModal',

        data: function () {
            return {
                modalShow: false,
                helper: YokumiruHelper,
            }
        },

        created: function () {
            bus.$on('open-modal-how-to-use-coupon', this.open)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-how-to-use-coupon')
        },

        methods: {
            /**
             * モーダル表示
             */
            open: function () {
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },
        },
    }
</script>

<style scoped lang="scss">
.vc-step {
    text-align: center;

    img {
        width: 100%;
    }
}
</style>
